import "./OptionGroup.css";

export interface OptionGroupOption {
  value: string;
  label: string;
}

export interface OptionGroupProps {
  title: string;
  icon?: string;
  options: OptionGroupOption[];
  value: string;
  onChange: (value: string) => void;
}

function OptionGroup({ title, icon, options, value, onChange }: OptionGroupProps) {
  return (
    <div className="option-group">
      <div className="option-group__header">
        {icon && (
          <img src={icon} alt="" className="option-group__icon" aria-hidden />
        )}
        <h3 className="option-group__title">{title}</h3>
      </div>
      <div className="option-group__options">
        {options.map((option) => (
          <div
            key={option.value}
            role="button"
            tabIndex={0}
            className="option-group__option"
            onClick={() => onChange(option.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onChange(option.value);
              }
            }}
            aria-pressed={value === option.value}
            aria-label={option.label}
          >
            <span className="option-group__label">{option.label}</span>
            <div
              className={`option-group__radio ${
                value === option.value ? "option-group__radio--selected" : ""
              }`}
            >
              {value === option.value && (
                <div className="option-group__radio-inner" />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default OptionGroup;
